<template>
    <router-view></router-view>
</template>
<script>
import InfosModalFR  from "./views/_commons/fr/modals/InfosModal" ;
import InfosModalNL  from "./views/_commons/nl/modals/InfosModal" ;
import sha256 from 'crypto-js/sha256';

export default {
    props: {
        resource_form: [Object, Array],
        prospect: [Object, Array],
    },
    watch: {
        '$route': {
            handler: function (to, from) {
                document.body.scrollTop = 0; // For Safari
                document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera

                dataLayer.push({
                    event: "virtualPageView",
                    virtualPageURL: this.$route.path,
                    virtualPageTitle: this.$route.params.step,
                    orderID: this.$store.get('general_data/match_token'),
                    websiteType: this.resource_form.name,
                    websiteSubType: this.resource_form.websubtype,
                    pageLanguage: this.resource_form.lang,
                    offer: this.resource_form.offer,
                    gift: this.resource_form.kdo,
                    gender: this.$store.get('form_data/gender'),
                    postcode: this.$store.get('form_data/zip_code'),
                    email: this.sha256(this.$store.get('form_data/email')),
                    paymentChoice: 'iban',
                    offerChoice: '2€/2mois',
                    promcode: _.get(queryString.parse(location.search), 'promo_code', this.resource_form.promo_code),
                    giftChoice: null,
                    formID: this.resource_form.id,
                })
                console.log(dataLayer)
            },
            immediate: true
        },
    },
    beforeCreate() {
        if (!_.isEmpty(_.get(window,'prospect'))) {
            this.$store.set('general_data/is_dirty',false);
            this.$store.set('general_data/current_step',null);
            this.$store.set('general_data/steps_track',[]);
            this.$store.set('general_data/steps_log',[]);
            this.$store.set('general_data/match_token', _.get(window.prospect, 'match_token', null));
            this.$store.set('form_data/gender', _.get(window.prospect, 'gender'));
            this.$store.set('form_data/firstname', _.get(window.prospect, 'firstname'));
            this.$store.set('form_data/lastname', _.get(window.prospect, 'lastname'));
            this.$store.set('form_data/email', _.get(window.prospect, 'email'));
            this.$store.set('form_data/phone', _.get(window.prospect, 'phone'));
            this.$store.set('general_data/sms_verified', _.get(window.prospect, 'sms_verified'));

            this.$store.set('form_data/street', _.get(window.prospect, 'street'));
            this.$store.set('form_data/street_number', _.get(window.prospect, 'street_number'));
            this.$store.set('form_data/street_box_number', _.get(window.prospect, 'street_box_number'));
            this.$store.set('form_data/zip_code', _.get(window.prospect, 'zip_code'));
            this.$store.set('form_data/city', _.get(window.prospect, 'city'));
            this.$store.set('form_data/source', _.get(window.prospect, 'source'));

            this.$store.set('form_data/optin_privacy', _.get(window.prospect, 'optin_privacy'));
            this.$store.set('form_data/optin_terms_conditions', _.get(window.prospect, 'optin_terms_conditions'));

        }
    },
    created() {
        if (!this.$store.get('general_data/device')) {
            this.$store.set('general_data/device', window.device);
        }
        if (!this.$store.get('general_data/version')) {
            this.$store.set('general_data/version', this.resource_form.version);
        }
        if (!this.$store.get('general_data/form_token')) {
            this.$store.set('general_data/form_token', this.resource_form.token);
        }

        // if (this.resource_form.part_2 == 1) {
        //     this.$store.set('general_data/match_token', _.get(this.prospect, 'match_token'));
        //     this.$store.set('general_data/steps_log', _.get(this.prospect, 'steps_log'));
        //     this.$store.set('general_data/query_string', _.get(this.prospect, 'query_string'));
        //     this.$store.set('general_data/part_1_complete', 1)
        // }

        this.$store.set('general_data/query_string',
            {
                ...this.$store.get('general_data/query_string')
                , ...window.queryString.parse(location.search)
            })
        this.$store.set('func_data/query_string', this.$store.get('general_data/query_string'))

        this.$store.set('form/resource_form', this.resource_form);
        this.$store.set('form/prospect', this.prospect);

        this.$store.set('general_data/country', this.resource_form.country);
        this.$store.set('general_data/id_privacy', this.resource_form.id_privacy);
        this.$store.set('general_data/lang', this.resource_form.lang);

        if (_.get(queryString.parse(location.search), 'utm_source', false)) {
            this.$store.set('func_data/utm_source', queryString.parse(location.search).utm_source);
        }

        let tracking_cookie = window.getCookie('_et_' + this.resource_form.slug)

        if (!_.isEmpty(tracking_cookie)) {
            let check = tracking_cookie.length == 36
            if (check && this.$store.get('general_data/session_uuid') != tracking_cookie) {
                this.$store.set('general_data/session_uuid', tracking_cookie);
        //         axios.post('/_et', {
        //             uuid: tracking_cookie,
        //             time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        //             time_type: '' + (new Date().getTimezoneOffset() / 60) * (-1),
        //             window_device: _.get(window,'device'),
        //             window_inner_width: _.get(window,'innerWidth'),
        //             window_inner_height: _.get(window,'innerHeight'),
        //             window_outer_width: _.get(window,'outerWidth'),
        //             window_outer_height: _.get(window,'outerHeight'),
        //             device_width: _.get(window,'screen.width'),
        //             device_height: _.get(window,'screen.height'),
        //             screen_orientation: _.get(window,'screen.orientation.type'),
        //             smartlook_key: _.get(window,'smartlook_key'),
        //         })
            }
        }
    },
    methods: {
        sha256(message){
            if(!message){
                return null;
            }
            return sha256(message).toString();
        },
        openInfosModal(tab) {
            this.$buefy.modal.open({
                component: this.resource_form.lang=='fr' ? InfosModalFR : InfosModalNL,
                props: {
                    activeTab: tab
                }
            })
        }
    },
    mounted() {
        let qs = queryString.parse(location.search);
        let tab = _.get(qs, 'modal')
        let tabArray = ['cookies', 'conditions', 'contact', 'privacy', 'faq'];
        if(tab && _.includes(tabArray,tab)){
            this.openInfosModal(tab)
        }
    }
};
</script>
